
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn
             color="primary"
             :class="{ 'float-right': floatRight }"
             v-bind="props"
             density="compact">
        <v-icon class="mr-2">mdi-plus</v-icon>
        Forma de pagamento
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" title="Nova forma de pagamento">
        <v-btn color="black" @click="dialog = false" density="compact"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormPaymentMethod v-model="value"
                           :user="user"
                           @created="createdObject"
                           @updated="updatedObject" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" density="compact" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormPaymentMethod from './FormPaymentMethod.vue';
export default {
  components: { FormPaymentMethod },
  props: {
    user: Object,
    modelValue: Object,
    floatRight: Boolean,
    hideButton: Boolean,
  },
  emits: ["update:modelValue", 'created', 'updated'],
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  methods: {
    createdObject(val) {
      this.dialog = false;
      this.$emit("created", val);
    },
    updatedObject(val) {
      this.dialog = false;
      this.$emit("updated", val);
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal && newVal?.id && !this.dialog) {
        this.dialog = true;
      }
    },
    // dialog(newVal) {
    //   if (!newVal) {
    //     this.value = {};
    //   }
    // },
  },
};
</script>
